export const CALL_TYPES = [
  {
    id: "discovery",
    title: "Discovery Call",
    description: "Help reps uncover customer needs, build rapport, and set the stage for a deal well done",
    enabled: true,
  },
  {
    id: "cold_call",
    title: "Cold Call",
    description: "Train reps to confidently open conversations, handle objections, and book meetings—cold call style.",
    enabled: true,
  },
  {
    id: "follow_up",
    title: "Follow-On call",
    description: "Prepare reps to dive deeper, address concerns, and drive momentum- next step unlocked.",
    enabled: false,
  },
  {
    id: "elevator_pitch",
    title: "Elevator Pitch",
    description: "Train reps to deliver a clear and confident value pitch.",
    enabled: true,
  }
];

export const DURATION_CHOICES = [{
  label: "5 mins",
  value: 5,
},{
  label: "10 mins",
  value: 10,
}, {
  label: "15 mins",
  value: 15,
}, {
  label: "20 mins",
  value: 20,
}, {
  label: "25 mins",
  value: 25,
}, {
  label: "30 mins",
  value: 30,
}];

export const DIFFICULTY_CHOICES = [{
  label: "Basic",
  value: "beginner",
}, {
  label: "Intermediate",
  value: "intermediate",
}, {
  label: "Advanced",
  value: "advanced",
}, {
  label: "Complex",
  value: "complex",
}];

export const TIME_BOUND_CHOICES = [{
  label: "30 sec",
  value: 30,
},{
  label: "1 min",
  value: 60,
}, {
  label: "1 min 30 sec",
  value: 90,
}, {
  label: "2 min",
  value: 120,
}]

function simulationFormat(formatValue: unknown): string {
  if (formatValue == null || formatValue === "") {
    return "";
  }
  return String(formatValue).trim().toLowerCase();
}

export function isSimulationVideoFormat(formatValue: unknown): boolean {
  return simulationFormat(formatValue) === "video";
}

export function isSimulationAudioFormat(formatValue: unknown): boolean {
  return simulationFormat(formatValue) === "audio";
}